export default __webpack_public_path__ + "static/media/background_5.a5e34794.jpg";